module.exports = __webpack_public_path__ + "static/img4-eb1d89f487b37774e59c8ef2233ff5aa.png";